import { CameraFacingMode } from '@yandex-360/telemost-sdk/device-manager';

export type AudioDeviceConstraints = object;
export interface VideoDeviceConstraints {
    aspectRatio?: ConstrainDouble;
    facingMode?: ConstrainDOMString;
    frameRate?: ConstrainDouble;
    height?: ConstrainULong;
    width?: ConstrainULong;
}

export type VideoResolution = '360p' | '720p';

export const VIDEO_RESOLUTION_CONSTRAINTS: Record<VideoResolution, VideoDeviceConstraints> = {
    '360p': {
        width: { ideal: 641 }, // 641 во избежание кропа и зума https://st.yandex-team.ru/CHEMODAN-75944
        height: { ideal: 360 },
        frameRate: { ideal: 24 },
    },
    '720p': {
        width: { ideal: 1280 },
        height: { ideal: 720 },
        frameRate: { ideal: 24 },
    },
};

export const MOBILE_VIDEO_CONSTRAINTS: VideoDeviceConstraints = {
    aspectRatio: {
        ideal: 4 / 3,
    },
    frameRate: { ideal: 24 },
};

export const getMobileVideoConstraints = (facingMode: 'user' | 'environment') => {
    const constraints = Object.assign({}, MOBILE_VIDEO_CONSTRAINTS);
    constraints.facingMode = { exact: facingMode };

    return constraints;
};

export const getDesktopVideoConstraints = () => {
    return VIDEO_RESOLUTION_CONSTRAINTS['720p'];
};

export const getVideoConstraints = (isMobile: boolean, facingMode: CameraFacingMode) => {
    if (isMobile) {
        return getMobileVideoConstraints(facingMode);
    }
    return getDesktopVideoConstraints();
};
